import React from 'react';
const ArrowSVG = ({ color = 'white', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="19"
      viewBox="0 0 26 19"
      fill="none"
      className={className}
    >
      <path
        d="M1.75 9.5H24.25M24.25 9.5L16.75 2M24.25 9.5L16.75 17"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowSVG;
